// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_1v-2";
export var blackBorderOnHover = "_1v-7";
export var cell = "_1v-6";
export var cellContainer = "_1v-3";
export var checked = "_1v-8";
export var disabled = "_1v-5";
export var featuredIconCellContainer = "_1v-9";
export var featuredIconTextContainer = "_1v-b";
export var featuredIconWrapper = "_1v-a";
export var noBorder = "_1v-c";
export var orangeSelectedRow = "_4p-3";
export var overflowableText = "_1v-0";
export var overflowableTextContainer = "_1v-1";
export var row = "_1w-0";
export var rowCheckboxCell = "_1v-4";
export var selectableTable = "_4p-2";